import React from 'react';
import Button from './Button';

// Shared search + filter toolbar. Search box and Clear button are built in;
// any other filter controls (date range, dropdowns, etc.) are passed as
// children so each page keeps its own filter fields without re-implementing
// the surrounding layout/spacing/clear-button convention every time.
const FilterBar = ({
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search...',
  children,
  hasActiveFilters = false,
  onClear,
  className = ''
}) => (
  <div className={`flex flex-col sm:flex-row sm:flex-wrap items-stretch sm:items-center gap-3 p-3 sm:p-4 bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm ${className}`}>
    {onSearchChange && (
      <div className="relative flex-1 min-w-[180px]">
        <i className="fas fa-search absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400 text-xs" aria-hidden="true"></i>
        <label htmlFor="filter-bar-search" className="sr-only">{searchPlaceholder}</label>
        <input
          id="filter-bar-search"
          type="text"
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder}
          className="w-full pl-9 pr-3 py-2.5 min-h-[40px] rounded-lg border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 text-sm outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
        />
      </div>
    )}

    {children}

    {hasActiveFilters && onClear && (
      <Button variant="ghost" size="sm" icon="fa-xmark" onClick={onClear} className="shrink-0">
        Clear Filters
      </Button>
    )}
  </div>
);

export default FilterBar;
